<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div>
      <v-data-table :headers="headers" :items="profediscinas" :sort-desc="true" class="elevation-1" :search="search">
        <template v-slot:item.indice="{ item }">
          <span>{{ profediscinas.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:item.photo="{ item }">
      <img class="photomouse" :src="getPhoto(item)" alt="avatar" width="30px;" />
       </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab small color="red" style="color:white;" v-bind="attrs" v-on="on"> <v-icon small @click="deleteItem(item)">delete</v-icon></v-btn>
            </template>
            <span>Remover disciplina atribuida</span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          Dados não encontrados!
        </template>

        <template v-slot:top>
          <div class="titlePageListar">
            <v-toolbar-title class="hidden-sm-and-down"> Associar Professor a Turma </v-toolbar-title>
          </div>

          <div class="searchPageListContainer">
            <v-text-field class="searchPageList" v-model="search" append-icon="search" label="PesquisarFuncionário"
              rounded single-line hide-details></v-text-field>
            <v-btn v-if="search" @click="initprofdisc(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          </div>

          <v-toolbar flat color="white">
            <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
              {{ $store.state.textMessage }}
            </div>

            <v-dialog v-model="dialog" max-width="800px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }} </span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                            {{ $store.state.textMessage }}
                          </div>
                        </v-col>

                        <v-col v-if="false" cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.idFuncionario" label="cod"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                          <v-overflow-btn :disabled="true" v-model="editedItem.professor" :items="professores" label="Funcionário" editable item-value="idProfessor" item-text="nome" @change="ChamaObterFuncionario"> </v-overflow-btn>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                          <v-combobox v-model="editedItem.curso" item-value="idCurso" item-text="descricao" @change="loadTurmaComb" @click="loadTurmaComb" :items="cursos" chips label="Curso"></v-combobox>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                          <v-combobox id="turma" v-model="editedItem.turma" item-value="pkturma" item-text="turmadescricao" @change="loadDiscpilanComb" @click="loadDiscpilanComb" :items="turmasFiltered" chips label="Turma"></v-combobox>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                          <v-combobox id="turma" v-model="editedItem.iddisciplina" item-value="iddisciplina" item-text="descricao" :items="disciplinasFiltered" chips label="Disciplina"></v-combobox>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn v-if="!replace" color="blue darken-1" :disabled="!(formValid)" text @click="save">Salvar</v-btn>
                  <v-btn v-if="replace" color=" darken-1" :disabled="!(formValid)" text @click="save(true)">Substituir O professor</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
      </v-data-table>
    </div>
    <carregarFoto :usuario="editedItem" :eventPhoto="eventPhoto" @fecharComponente="fecharTelaComponente" v-if="menuSelected === 1"></carregarFoto>
  </div>
</template>
<script>
import axios from '../../../plugins/axios'
import carregarFoto from '../componentes/usuario/carregarfoto.vue'
import photoUser from '../../../utilitarios/photo.services'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  components: {
    carregarFoto
  },
  data: () => ({
    eventPhoto: null,
    menuSelected: 0,
    dialogoUpload: false,
    imgSrc: '',
    roles: 'func',
    overlay: false,
    replace: false,
    disciplinas: [],
    disciplinasFiltered: [],
    professordiscijaexiste: [],
    text: '',
    flag_curso: '',
    formValid: true,
    isLoading: false,
    turmasAll: [],
    turmasFiltered: [],
    search: '',
    cursos: [],
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    headers: [
      { text: '#', value: 'indice' },
      { text: 'Foto', value: 'photo' },
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Lecciona', value: 'descricao' },
      { text: 'Turma & Sala', value: 'turma' },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Ano Lectivo', value: 'anolectivo' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      idfuncionario: null,
      iddisciplina: 0,
      idpessoa: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''

    },
    defaultItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Atribuir Disciplina ao Professor' : 'Editar'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // check if classe has been selected otherwise send back to painel to select
    this.iniprofessores()
    this.initprofdisc()
    this.initializeCursos()
    this.initializeturmasAll()
    this.initializedisciplinas()
  },

  methods: {
    getPhoto (item) {
      try {
        return photoUser.getPhotoUser(item.idPEssoa)
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao carregar a foto', 'error')
      }
    },
    async initprofdisc (search) {
      let payload
      try {
        this.overlay = true
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios.get('/professordiscFindAll/' + payload).then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro ao realizar a operação!', 'error')
      } finally {
        this.overlay = false
      }
    },

    ChamaObterFuncionario () {
      let idp = this.editedItem.professor.toString().split('-')[0]
      this.ObterIdFuncionario(idp)
    },

    async iniprofessores (search) {
      let payload
      this.this.overlay = true
      try {
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios.get('/professorFindAll/' + payload).then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro ao realizar a operação!', 'error')
      } finally {
        this.overlay = false
      }
    },
    async initializeCursos () {
      try {
        this.overlay = true
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro ao realizar a operação!', 'error')
      } finally {
        this.overlay = false
      }
    },

    async initializedisciplinas () {
      try {
        this.overlay = true
        this.disciplinas = await axios.get('/disciplinaFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro ao realizar a operação!', 'error')
      } finally {
        this.overlay = false
      }
    },

    loadDiscpilanComb (turma) {
      this.disciplinasFiltered = this.disciplinas.filter(t => t.idCurso === turma.idCurso && t.anoacademico === turma.idAno_Academico)
    },

    loadTurmaComb (curso) {
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
    },

    async initializeturmasAll () {
      try {
        this.overlay = true
        this.turmasAll = await axios.get('/turmaFindAll/').then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro ao realizar a operação!', 'error')
      } finally {
        this.overlay = false
      }
    },

    editItem (item) {
      this.editedIndex = this.profediscinas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.professor = this.professores.filter((p) => p.nome === item.nome)[0]
      this.editedItem.curso = this.cursos.filter((c) => c.descricao === item.curso)[0]
      this.editedItem.turma = this.turmasAll.filter((t) => t.turmadescricao === item.turma)[0]
      this.editedItem.iddisciplina = this.disciplinas.filter((d) => d.descricao === item.descricao && d.iddisciplina === item.iddisciplina)[0]
      this.loadTurmaComb(this.editedItem.curso)
      this.loadDiscpilanComb(this.editedItem.turma)
      this.dialog = true
    },

    // handleDelete(row) {
    //   const swalWithBootstrapButtons3 = Swal.mixin({
    //     customClass: {
    //       confirmButton: "btn btn-success btn-fill",
    //       cancelButton: "btn btn-danger btn-fill",
    //     },
    //     buttonsStyling: false,
    //   });
    //   swalWithBootstrapButtons3.fire({
    //     title: "Deseja continuar com a operação ? ",
    //     text: `Não poderá reverter esta operação!`,
    //     showCancelButton: true,
    //     confirmButtonText: "Continuar",
    //   }).then((result) => {

    //     console.log(result, 'Ris')
    //     if (result.isConfirmed) {
    //       // cursoService.EliminarComponeteAssociado({ id: row.id, instituicao: row.idInstituicao }).then((res) => {
    //       //   if (res.data.affectedRows === 1) {
    //       //     swalWithBootstrapButtons3.fire({
    //       //       title: "Eliminado!",
    //       //       text: 'Componente eliminado com sucesso',
    //       //     });

    //       //     this.deleteRow(row);
    //       //     this.Initialize();
    //       //   } else {
    //       //     store.methods.showAlert("top-center", "error", "Ocorreu um erro ao tentar efectuar a operação.", null);
    //       //   };
    //       // })
    //     }
    //   });
    // },

    deleteItem (item) {
        Swal.fire({
          title: "Eliminar ?",
          text: "Clique em continuar se deseja eliminar essa atribuição.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Continuar",
          cancelButtonText:"Cancelar",
          reverseButtons:true
        }).then(async(result) => {
          if (result.isConfirmed) {
             let result = await this.EliminarDisciplinaAtribuida(item)
             if(result.affectedRows >= 1){
                Swal.fire('Informação','Atribuição eliminada com sucesso','success')
                 const index = this.profediscinas.indexOf(item)
                  this.profediscinas.splice(index, 1)
             }
             
          }
        });
      
    },

    close () {
      this.replace = false
      this.dialog = false
      this.iniprofessores()
      this.initprofdisc()
      this.initializeCursos()
      this.initializeturmasAll()
      this.initializedisciplinas()
    },

    save (replace) {
      this.professordiscijaexiste = this.profediscinas.filter(
        p => p.iddisciplina === this.editedItem.iddisciplina.iddisciplina && p.turma === this.editedItem.turma.turmadescricao
      )

      if (!this.professordiscijaexiste.length > 0 || this.editedItem.idProfessorDisciTurma > 0 || replace === true) {
        this.saveprof(replace)
      } else {
        this.replace = true
        this.$store.dispatch('textMessage', {
          msg: this.professordiscijaexiste[0].nome + ' é o professor que  lecciona  ' + this.editedItem.iddisciplina.descricao.toUpperCase() + ' na turma  ' + this.editedItem.turma.turmadescricao,
          classMessage: 'msgError',
          timeout: 7000
        })
      }
    },


    async EliminarDisciplinaAtribuida(params){

        try {
          return  await axios.post('/eliminarAtribuicaoDisciplina',params).then(res => res.data)
        } catch (error) {
           Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
        }

    },

    async ObterIdFuncionario (valor) {
      this.overlay = true
      try {
        this.editedItem.idfuncionario = await axios.get('/ObterIdFuncionario/' + valor).then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro ao realizar a operação!', 'error')
      } finally {
        this.overlay = false
      }

      if (this.editedItem.idfuncionario != null) { this.ObterIdPessoa(this.editedItem.idfuncionario) }
    },

    async ObterIdPessoa (valor) {
      this.overlay = true
      try {
        this.editedItem.idpessoa = await axios.get('/ObterIdPessoa/' + valor.idFuncionario).then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro ao realizar a operação!', 'error')
      } finally {
        this.overlay = false
      }
    },

    Actualizar (replace) {
      if (this.professordiscijaexiste.length) {
        let indice = this.profediscinas.indexOf(this.professordiscijaexiste[0])
        this.profediscinas.splice(indice, 1)
      }
    },

    async saveprof (replace) {
      if (this.professordiscijaexiste.length) {
        var params = {
          idProfessorDisciTurma: (this.professordiscijaexiste.length) ? this.professordiscijaexiste[0].idProfessordisciturma : 0,
          idTurma: this.editedItem.turma.idTurma,
          iddisciplina: this.editedItem.iddisciplina.iddisciplina,
          idProfessor: this.editedItem.professor.toString().split('-')[0],
          fkTurma: this.editedItem.turma.pkTurma,
          desciplinaDescricao: this.editedItem.iddisciplina.descricao,
          idpessoa: this.editedItem.idpessoa.idpessoa

        }
      } else {
        try {
          // eslint-disable-next-line no-unused-vars
          let params =
          {
            idProfessorDisciTurma: 0,
            idTurma: this.editedItem.turma.idTurma,
            iddisciplina: this.editedItem.iddisciplina.iddisciplina,
            idProfessor: this.editedItem.professor.toString().split('-')[0],
            fkTurma: this.editedItem.turma.pkTurma,
            desciplinaDescricao: this.editedItem.iddisciplina.descricao,
            idpessoa: this.editedItem.idpessoa.idpessoa
          }
        } catch (error) {
        }
      }

      try {
        // eslint-disable-next-line camelcase
        let cor_mensagem = 'msgError'
        let msg = await axios
          .post('/professordisciInsertOrUpdate', params)
          .then(res => res.data)
        // this.text = msg[1].insertId

        // Verificação da mensagem retornada pelo server
        if (msg.length) {
          let erro = msg[0]
          this.text = 'Ocorreu um erro ao tentar efectuar a operação.\n' + erro[0].Message
          // eslint-disable-next-line camelcase
          cor_mensagem = 'msgError'
        } else {
          this.text = 'Operação efectuada com sucesso.'
          // eslint-disable-next-line camelcase
          cor_mensagem = 'msgSucess'
          this.Actualizar(replace)
          // Adiciona os dados na coleção
          let coll = {
            nome: this.editedItem.professor.toString().split('-')[1],
            descricao: this.editedItem.iddisciplina.descricao,
            turma: this.editedItem.turma.turmadescricao,
            periodo: this.editedItem.turma.periodo,
            curso: this.editedItem.turma.curso,
            anolectivo: this.editedItem.turma.anoLectivo
          }

          this.profediscinas.unshift(coll)
          this.close()
        }
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: cor_mensagem,
          timeout: 4000
        })
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      }
    },
    fecharTelaComponente () {
      this.menuSelected = 0
      this.initialize()
    },
    setImage (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        Swal.fire({ icon: 'warning', title: '', text: 'Por favor selecione uma imagem' })
      } else {
        if (typeof FileReader === 'function') {
          this.eventPhoto = e
          this.menuSelected = 1
        } else {
          Swal.fire({ icon: 'warning', title: '', text: 'Ficheiro não suportado' })
        }
      }
    },
    showFileChooser (item) {
      this.editedItem = item
      this.$refs.input.click()
    }
  }
}
</script>
<style scoped>
.titlePageListar {
  text-align: center;
}

.searchPageListContainer {
  width: 30%;
  margin: 10px auto 0;
  display: flex;
}

.searchPageList {
  border: 1px solid #434343;
  border-radius: 30px;
}
</style>
